import store from "../../store";
import {
  onSavedSearchChange,
  setDefaultAssociationForAgreement,
  setSelectedAgreement,
  setSelectedAssociation,
  setSelectedAssociationInstance,
  setSelectedAttributes,
  setSelectedFolder,
  setSelectedFolderInstance,
  storeAgreementData,
  storeAssociationData,
  storeAssociationInstancesData,
  storeAttributeData,
  storeEmailAttachmentFormData,
  storeEmailThreadFormData,
  storeFolderData,
  storeFolderInstancesData,
  storeSavedSearchData,
} from "../add-to-ici/redux/slice";
import { VIEW_FOLDER_AND_DOCUMENTS } from "../../shared/constants/addToICIToggleView";
import { FILE_TYPES } from "../../shared/constants/fileTypes";
import { TEXT } from "../../shared/constants/texts";
import { UPLOAD_FLOW, UPLOAD_TYPE, UPLOAD_REQUEST_FROM } from "../../shared/constants/uploadParams";
import { EMAIL_FILE_TYPE } from "../../shared/constants/emailThreadFormats";

export const transformSavedSearchData = (data) => {
  let transformedSavedSearchData = [];
  const savedSearchData = data && data.ICMExecuteSavedSearchList ? JSON.parse(data.ICMExecuteSavedSearchList) : [];
  if (savedSearchData.length > 0) {
    transformedSavedSearchData = savedSearchData.map((data) => {
      return {
        id: data.id,
        label: data.name,
        value: data.name,
        entityName: data.entityName,
      };
    });
  }
  return transformedSavedSearchData;
};

export const updateSavedSearchData = (data) => {
  store.dispatch(storeSavedSearchData(data));
};

export const setSelectedSavedSearchData = (data) => {
  store.dispatch(onSavedSearchChange(data));
};

export const transformAttributeData = (data) => {
  let attributeData = [];
  for (let key in data) {
    if (key !== "$type") {
      let attrData = {};
      for (let value of data[key]) {
        if (value.Key === "AttributeId") {
          attrData = { ...attrData, attributeId: value.Value };
        }
        if (value.Key === "Name") {
          attrData = { ...attrData, name: value.Value };
        }
        if (value.Key === "ICMDisplayName") {
          attrData = { ...attrData, displayName: value.Value };
        }
        if (value.Key === "DataType") {
          attrData = { ...attrData, dataType: value.Value };
        }
        if (value.Key === "IsAttributeLocalized") {
          attrData = { ...attrData, isAttributeLocalised: value.Value };
        }
      }
      attributeData.push({
        id: key,
        ...attrData,
      });
    }
  }
  if (attributeData.length > 0) {
    attributeData = Array.from(
      new Map(attributeData.map((attribute) => [attribute["attributeId"], attribute])).values()
    ).sort((a, b) => a.displayName.toLowerCase().localeCompare(b.displayName.toLowerCase()));
  }
  return attributeData;
};

export const updateAttributeData = (data) => {
  store.dispatch(storeAttributeData(data));
};

export const setSelectedAttributeData = (data) => {
  store.dispatch(setSelectedAttributes(data));
};

export const updateAgreementData = (data) => {
  store.dispatch(storeAgreementData(data));
};

export const setSelectedAgreementData = (data) => {
  store.dispatch(setSelectedAgreement(data));
};

export const transformAssociationPartOneData = (data) => {
  const associationData = data.filter((association) => association.AssociationType !== 0);
  const ids = associationData.map((association) => association.AssociatedEntityId).join(",");
  return ids;
};

export const transformAssociationPartTwoData = ({ responsePartOne, responsePartTwo }) => {
  const associationsData =
    responsePartTwo && responsePartTwo.length > 0
      ? responsePartTwo.map((association) => {
          return {
            ...association,
            label: association.ICMDisplayName,
            value: association.ICMDisplayName,
            name: association.ICMDisplayName,
          };
        })
      : [];
  const filteredAssociationsData =
    associationsData && associationsData.length > 0
      ? associationsData.filter(
          (item) => !item.ICMDisplayName.toLowerCase().includes("amendment") && item.AllowDocumentUpload
        )
      : [];
  const transformedFilteredAssociationsData =
    filteredAssociationsData && filteredAssociationsData.length > 0
      ? filteredAssociationsData.map((ele) => {
          const filteredData = responsePartOne
            ? responsePartOne.filter((item) => item.AssociatedEntityId.toLowerCase() === ele.EntityInstanceId)
            : [];
          if (filteredData.length > 0) {
            return {
              ...ele,
              parentName: filteredData[0].AssociationName,
            };
          }
          return ele;
        })
      : [];
  return transformedFilteredAssociationsData;
};

export const updateAssociationData = (data) => {
  store.dispatch(storeAssociationData(data));
};

export const setSelectedAssociationData = (data) => {
  store.dispatch(setSelectedAssociation(data));
};

export const setSelectedDefaultAssociationData = (data) => {
  store.dispatch(setDefaultAssociationForAgreement(data));
};

export const transformFolderData = (data) => {
  let transformedFolderData = null;
  let finalFolderData = null;
  for (let key in data) {
    if (key !== "$type") {
      transformedFolderData = data[key];
    }
  }
  if (transformedFolderData) {
    for (let val of transformedFolderData) {
      if (val.Key === "FolderStructureJson") {
        finalFolderData = val.Value ? JSON.parse(val.Value) : null;
      }
    }
  }
  return { transformedFolderData, finalFolderData };
};

export const updateFolderData = (data) => {
  store.dispatch(storeFolderData(data));
};

export const setSelectedFolderData = (data) => {
  store.dispatch(setSelectedFolder(data));
};

export const updateAssociationInstanceData = (data) => {
  store.dispatch(storeAssociationInstancesData(data));
};

export const setSelectedAssociationInstanceData = (data) => {
  store.dispatch(setSelectedAssociationInstance(data));
};

export const updateFolderInstanceData = (data) => {
  store.dispatch(storeFolderInstancesData(data));
};

export const setSelectedFolderInstanceData = (data) => {
  store.dispatch(setSelectedFolderInstance(data));
};

export const updateEmailAttachmentFormData = (data) => {
  store.dispatch(storeEmailAttachmentFormData(data));
};

export const updateEmailThreadFormData = (data) => {
  store.dispatch(storeEmailThreadFormData(data));
};

export const getUploadRequestData = async (dataForRequest) => {
  const { state, dnd, type, from, flow, uploadData, files, fromUnitTest = false } = dataForRequest;
  const {
    singleEmailData,
    selectedEmailThreadFormat,
    selectedAssociation,
    defaultAssociationOfAgreement,
    selectedFolder,
    associationData,
    selectedViewFolderAndDocuments,
    selectedAgreement,
    isMajorVersion,
    isMajorVersionConfigured,
    selectedVersionLabel,
    isVersionLabelsConfigured,
  } = state;
  const { itemId, itemClass, subject } = singleEmailData;
  let uploadAttachmentRequestData = [];
  if (flow === UPLOAD_FLOW.DRAG_AND_DROP) {
    const fileType = selectedEmailThreadFormat.id;
    let name = TEXT.MSG_REQUEST_NAME;
    let label = TEXT.MSG_REQUEST_LABEL;
    let tooltip = TEXT.MSG_REQUEST_TOOLTIP;
    if (fileType === EMAIL_FILE_TYPE.DOCX) {
      name = TEXT.DOCX_REQUEST_NAME;
      label = TEXT.DOCX_REQUEST_LABEL;
      tooltip = TEXT.DOCX_REQUEST_TOOLTIP;
    }
    const requestData = {
      attachmentType: "file",
      contentType: "",
      isInline: false,
      size: dnd ? "" : "0",
      isEmailAsAnAttachment: true,
      fileType: fileType,
      isMapped: true,
      isAgreement: false,
      uniqueId: dnd ? "" : Math.floor(Math.random() * 1000000000000).toString(),
      status: dnd ? "" : "Uploading",
      action: dnd ? 0 : type === UPLOAD_TYPE.REPLACE_EXISTING ? 0 : 1,
    };
    if (
      from === UPLOAD_REQUEST_FROM.AGREEMENT ||
      from === UPLOAD_REQUEST_FROM.ASSOCIATION ||
      from === UPLOAD_REQUEST_FROM.FOLDER
    ) {
      if (type === UPLOAD_TYPE.NEW_DOCUMENT) {
        for (const file of files) {
          const requestDataNewDocument = {
            name: file.name,
            Base64PayloadString: file.b64,
            isSelected: false,
            agreementId: "",
            messageClass: "IPM.Note",
            Id: "",
            associationName: "",
            parentName: "",
            FileNameWithExtension: file.name,
            FileNameWithoutExtension: getFileNameWithoutExtension(file.name) || file.name,
          };
          if (from === UPLOAD_REQUEST_FROM.AGREEMENT) {
            const { defaultAssociation } = uploadData;
            uploadAttachmentRequestData.push({
              ...requestData,
              ...requestDataNewDocument,
              contractTypeName: defaultAssociation.Name,
            });
          }
          if (from === UPLOAD_REQUEST_FROM.ASSOCIATION) {
            uploadAttachmentRequestData.push({
              ...requestData,
              ...requestDataNewDocument,
              contractTypeName: selectedAssociation.Name,
            });
          }
          if (from === UPLOAD_REQUEST_FROM.FOLDER) {
            uploadAttachmentRequestData.push({
              ...requestData,
              ...requestDataNewDocument,
              contractTypeName: defaultAssociationOfAgreement.Name,
              FolderReference: selectedFolder.id,
            });
          }
        }
      }
      if (type === UPLOAD_TYPE.REPLACE_EXISTING) {
      }
      if (type === UPLOAD_TYPE.KEEP_BOTH) {
      }
    }
    if (from === UPLOAD_REQUEST_FROM.ASSOCIATION_INSTANCE || from === UPLOAD_REQUEST_FROM.FOLDER_INSTANCE) {
      const { data, id } = uploadData;
      if (type === UPLOAD_TYPE.REPLACE_EXISTING) {
        let requestDataInstance = {
          name: name,
          id: itemId,
          messageClass: itemClass,
          label: label,
          tooltip: tooltip,
          agreementId: data.SysId,
          associationName: data.Name ? data.Name : data.ICMAgreementCode,
          FolderReference: id,
          FileNameWithExtension: subject ? subject + ".msg" : "",
          FileNameWithoutExtension: subject,
        };
        if (!fromUnitTest) {
          // @ts-ignore
          requestDataInstance = { ...requestDataInstance, Base64PayloadString: await getAsFileAsyncPromise() };
        }
        if (from === UPLOAD_REQUEST_FROM.ASSOCIATION_INSTANCE) {
          uploadAttachmentRequestData.push({
            ...requestData,
            ...requestDataInstance,
            contractTypeName: selectedAssociation.Name,
            parentName: selectedAssociation.parentName,
          });
        }
        if (from === UPLOAD_REQUEST_FROM.FOLDER_INSTANCE) {
          uploadAttachmentRequestData.push({
            ...requestData,
            ...requestDataInstance,
            contractTypeName: defaultAssociationOfAgreement.Name,
            parentName: defaultAssociationOfAgreement.parentName,
          });
        }
      }
    }
  }
  if (flow === UPLOAD_FLOW.SINGLE_EMAIL_UPLOAD) {
    const { emailThreadFormData, emailAttachmentFormData } = uploadData;
    const isFolderView =
      selectedViewFolderAndDocuments && selectedViewFolderAndDocuments.id === VIEW_FOLDER_AND_DOCUMENTS[1].id;
    if (emailThreadFormData) {
      const fileType = selectedEmailThreadFormat.id;
      let name = TEXT.MSG_REQUEST_NAME,
        label = TEXT.MSG_REQUEST_LABEL,
        tooltip = TEXT.MSG_REQUEST_TOOLTIP;
      if (fileType === EMAIL_FILE_TYPE.DOCX) {
        name = TEXT.DOCX_REQUEST_NAME;
        label = TEXT.DOCX_REQUEST_LABEL;
        tooltip = TEXT.DOCX_REQUEST_TOOLTIP;
      }
      const {
        selectedUploadType,
        selectedAssociation,
        newDocumentName,
        selectedFolderNewDocument,
        replaceAssociationInstance,
        replaceFolderInstance,
        selectedFolderReplaceExisting,
      } = emailThreadFormData;
      const { itemId, itemClass, subject } = singleEmailData;
      const fileNameWithExtension = subject ? removeInvalidChars(subject) + ".msg" : "";
      const fileNameWithoutExtension = removeInvalidChars(subject);
      let requestAttachmentData = {
        attachmentType: "file",
        contentType: "",
        id: itemId,
        messageClass: itemClass,
        isInline: false,
        name: name,
        label: label,
        tooltip: tooltip,
        size: "0",
        isEmailAsAnAttachment: true,
        fileType: fileType,
        isMapped: true,
        isAgreement: false,
        uniqueId: Math.floor(Math.random() * 1000000000000).toString(),
        contractTypeName: selectedAssociation.Name,
        parentName: selectedAssociation.parentName,
        status: "Uploading",
        FileNameWithExtension: fileNameWithExtension,
        FileNameWithoutExtension: fileNameWithoutExtension,
      };
      if (!fromUnitTest) {
        // @ts-ignore
        requestAttachmentData = { ...requestAttachmentData, Base64PayloadString: await getAsFileAsyncPromise() };
      }
      if (selectedUploadType === TEXT.NEW_DOCUMENT || selectedUploadType === TEXT.KEEP_BOTH) {
        uploadAttachmentRequestData.push({
          ...requestAttachmentData,
          action: 1,
          associationName: newDocumentName,
          FolderReference: selectedFolderNewDocument ? selectedFolderNewDocument.id : null,
        });
      }
      if (selectedUploadType === TEXT.REPLACE_EXISTING) {
        uploadAttachmentRequestData.push({
          ...requestAttachmentData,
          action: 0,
          agreementId: !isFolderView ? replaceAssociationInstance.SysId : replaceFolderInstance.sysId,
          associationName: !isFolderView
            ? replaceAssociationInstance.Name
              ? replaceAssociationInstance.Name
              : replaceAssociationInstance.ICMAgreementCode
            : replaceFolderInstance.Name
              ? replaceFolderInstance.Name
              : replaceFolderInstance.ICMAgreementCode,
          FolderReference: isFolderView ? selectedFolderReplaceExisting.id : null,
        });
      }
    }
    if (emailAttachmentFormData) {
      const uploadableData = emailAttachmentFormData.filter((item) => {
        const {
          selectedAssociation,
          selectedUploadType,
          replaceAssociationInstance,
          newDocumentName,
          replaceFolderInstance,
          selectedFolderNewDocument,
        } = item;
        return (
          (selectedAssociation &&
            selectedUploadType &&
            (replaceAssociationInstance || (newDocumentName && !isFolderView))) ||
          (selectedAssociation &&
            selectedUploadType &&
            (replaceFolderInstance || (newDocumentName && selectedFolderNewDocument))) ||
          (selectedAssociation && selectedAssociation.id === TEXT.AGREEMENT_NEW_VERSION)
        );
      });
      for (const item of uploadableData) {
        const {
          attachment,
          selectedAssociation,
          selectedUploadType,
          newDocumentName,
          replaceAssociationInstance,
          selectedFolderNewDocument,
          selectedFolderReplaceExisting,
          replaceFolderInstance,
        } = item;
        const fileTypeArr = attachment.name.split(".");
        const fileTypeStr = fileTypeArr[fileTypeArr.length - 1].toLowerCase();
        let fileType = 0;
        if (!fromUnitTest && attachment.attachmentType === Office.MailboxEnums.AttachmentType.Item) {
          fileType = FILE_TYPES["msg"];
        } else {
          fileType = FILE_TYPES[fileTypeStr];
        }
        let requestAttachmentData = {
          id: attachment.id,
          name: attachment.name,
          contentType: attachment.contentType,
          size: attachment.size,
          attachmentType: attachment.attachmentType,
          isInline: attachment.isInline,
          fileType,
          isEmailAsAnAttachment: false,
          isMapped: true,
          uniqueId: Math.floor(Math.random() * 1000000000000).toString(),
          status: "Uploading",
          FileNameWithExtension: attachment.name,
          FileNameWithoutExtension: getFileNameWithoutExtension(attachment.name) || attachment.name,
          IsMajorVersion: isMajorVersionConfigured ? isMajorVersion : true,
          VersionLabel: isVersionLabelsConfigured
            ? selectedVersionLabel
              ? selectedVersionLabel.DisplayName
                ? selectedVersionLabel.DisplayName
                : selectedVersionLabel.Name
                  ? selectedVersionLabel.Name
                  : ""
              : ""
            : "",
        };
        if (!fromUnitTest) {
          const base64Attachment = await getAttachmentContentAsyncPromise(attachment.id);
          requestAttachmentData = {
            ...requestAttachmentData,
            // @ts-ignore
            Base64PayloadString: base64Attachment.content ? base64Attachment.content : "",
            // @ts-ignore
            Base64PayloadFormat: base64Attachment.format ? base64Attachment.format : "",
          };
        }
        if (selectedAssociation && selectedAssociation.id === TEXT.AGREEMENT_NEW_VERSION) {
          uploadAttachmentRequestData.push({
            ...requestAttachmentData,
            isSelected: false,
            isAgreement: true,
            contractTypeName: selectedAgreement.entityName,
            associationName: selectedAgreement.entityName,
            agreementId: selectedAgreement.sysId,
            action: 0,
          });
        }
        if (selectedUploadType === TEXT.NEW_DOCUMENT) {
          uploadAttachmentRequestData.push({
            ...requestAttachmentData,
            isAgreement: false,
            action: 1,
            contractTypeName: selectedAssociation.Name,
            associationName: newDocumentName,
            parentName: selectedAssociation.parentName,
            FolderReference: isFolderView ? selectedFolderNewDocument.id : null,
          });
        }
        if (selectedUploadType === TEXT.REPLACE_EXISTING) {
          uploadAttachmentRequestData.push({
            ...requestAttachmentData,
            isAgreement: false,
            action: 0,
            contractTypeName: selectedAssociation.Name,
            parentName: selectedAssociation.parentName,
            agreementId: !isFolderView ? replaceAssociationInstance.SysId : replaceFolderInstance.sysId,
            associationName: !isFolderView
              ? replaceAssociationInstance.Name
                ? replaceAssociationInstance.Name
                : replaceAssociationInstance.ICMAgreementCode
              : replaceFolderInstance.Name
                ? replaceFolderInstance.Name
                : replaceFolderInstance.ICMAgreementCode,
            FolderReference: isFolderView ? selectedFolderReplaceExisting.id : null,
          });
        }
      }
    }
  }
  if (flow === UPLOAD_FLOW.DRAG_AND_DROP_SINGLE_EMAIL_THREAD) {
    const fileType = selectedEmailThreadFormat.id;
    const { itemId, itemClass, subject } = singleEmailData;
    let name = TEXT.MSG_REQUEST_NAME;
    let label = TEXT.MSG_REQUEST_LABEL;
    let tooltip = TEXT.MSG_REQUEST_TOOLTIP;
    if (fileType === EMAIL_FILE_TYPE.DOCX) {
      name = TEXT.DOCX_REQUEST_NAME;
      label = TEXT.DOCX_REQUEST_LABEL;
      tooltip = TEXT.DOCX_REQUEST_TOOLTIP;
    }
    const fileNameWithExtension = subject ? removeInvalidChars(subject) + ".msg" : "";
    const fileNameWithoutExtension = removeInvalidChars(subject);
    let requestData = {
      id: itemId,
      messageClass: itemClass,
      attachmentType: "file",
      contentType: "",
      name: name,
      label: label,
      tooltip: tooltip,
      isInline: false,
      size: "0",
      isEmailAsAnAttachment: true,
      fileType: fileType,
      isMapped: true,
      isAgreement: false,
      uniqueId: Math.floor(Math.random() * 1000000000000).toString(),
      status: "Uploading",
      action: 1,
      associationName: subject,
      FileNameWithExtension: fileNameWithExtension,
      FileNameWithoutExtension: fileNameWithoutExtension,
    };
    if (!fromUnitTest) {
      // @ts-ignore
      requestData = { ...requestData, Base64PayloadString: await getAsFileAsyncPromise() };
    }
    if (
      from === UPLOAD_REQUEST_FROM.AGREEMENT ||
      from === UPLOAD_REQUEST_FROM.ASSOCIATION ||
      from === UPLOAD_REQUEST_FROM.FOLDER
    ) {
      if (type === UPLOAD_TYPE.NEW_DOCUMENT) {
        if (from === UPLOAD_REQUEST_FROM.AGREEMENT) {
          const { defaultAssociation } = uploadData;
          uploadAttachmentRequestData.push({
            ...requestData,
            contractTypeName: defaultAssociation.Name,
            parentName: defaultAssociation.parentName,
          });
        }
        if (from === UPLOAD_REQUEST_FROM.ASSOCIATION) {
          uploadAttachmentRequestData.push({
            ...requestData,
            contractTypeName: selectedAssociation.Name,
            parentName: selectedAssociation.parentName,
          });
        }
        if (from === UPLOAD_REQUEST_FROM.FOLDER) {
          uploadAttachmentRequestData.push({
            ...requestData,
            contractTypeName: defaultAssociationOfAgreement.Name,
            parentName: defaultAssociationOfAgreement.parentName,
            FolderReference: selectedFolder.id,
          });
        }
      }
    }
  }
  if (flow === UPLOAD_FLOW.SINGLE_EMAIL_THREAD_UPLOAD_REPLACE_POPUP) {
    const { data } = uploadData;
    const { AssociationDetailsOnDragDrop, MessageId } = data;
    const associations =
      associationData && associationData.length > 0
        ? associationData
        : JSON.parse(localStorage.getItem("associationData"));
    const {
      AssociationName,
      InstanceName,
      InstanceAgreementCode,
      InstanceId,
      FolderReference,
      ContractTypeName,
      Base64PayloadString,
    } = AssociationDetailsOnDragDrop;
    const fileType = selectedEmailThreadFormat.id;
    let name = TEXT.MSG_REQUEST_NAME;
    let label = TEXT.MSG_REQUEST_LABEL;
    let tooltip = TEXT.MSG_REQUEST_TOOLTIP;
    if (fileType === EMAIL_FILE_TYPE.DOCX) {
      name = TEXT.DOCX_REQUEST_NAME;
      label = TEXT.DOCX_REQUEST_LABEL;
      tooltip = TEXT.DOCX_REQUEST_TOOLTIP;
    }
    if (type === UPLOAD_TYPE.REPLACE_EXISTING) {
      const association =
        associations && associations.length > 0
          ? associations.filter((association) => association.Name === AssociationName)
          : [];
      let requestData = {
        attachmentType: "file",
        contentType: "",
        isInline: false,
        size: dnd ? "" : "0",
        isEmailAsAnAttachment: true,
        fileType: fileType,
        isMapped: true,
        isAgreement: false,
        uniqueId: dnd ? "" : Math.floor(Math.random() * 1000000000000).toString(),
        status: dnd ? "" : "Uploading",
        action: dnd ? 0 : type === UPLOAD_TYPE.REPLACE_EXISTING ? 0 : 1,
        name: name,
        id: MessageId,
        messageClass: "IPM.Note",
        label: label,
        tooltip: tooltip,
        agreementId: InstanceId,
        associationName: InstanceName ? InstanceName : InstanceAgreementCode,
        FolderReference: FolderReference ? FolderReference : null,
        contractTypeName: association[0].Name,
        parentName: association[0].parentName,
        FileNameWithExtension: InstanceName ? InstanceName + ".msg" : "",
        FileNameWithoutExtension: InstanceName,
      };
      if (!fromUnitTest) {
        // @ts-ignore
        requestData = { ...requestData, Base64PayloadString: await getAsFileAsyncPromise() };
      }
      uploadAttachmentRequestData.push(requestData);
    }
    if (type === UPLOAD_TYPE.KEEP_BOTH) {
      const association =
        associations && associations.length > 0
          ? associations.filter((association) => association.Name === ContractTypeName)
          : [];
      uploadAttachmentRequestData.push({
        attachmentType: "file",
        contentType: "",
        isInline: false,
        size: dnd ? "" : "0",
        isEmailAsAnAttachment: true,
        fileType: fileType,
        isMapped: true,
        isAgreement: false,
        uniqueId: dnd ? "" : Math.floor(Math.random() * 1000000000000).toString(),
        status: dnd ? "" : "Uploading",
        action: dnd ? 0 : type === UPLOAD_TYPE.REPLACE_EXISTING ? 0 : 1,
        name: InstanceName ? InstanceName : InstanceAgreementCode,
        Base64PayloadString: Base64PayloadString,
        isSelected: false,
        agreementId: "",
        messageClass: "IPM.Note",
        Id: "",
        associationName: "",
        parentName: "",
        contractTypeName: association[0].Name,
        FileNameWithExtension: InstanceName ? InstanceName + ".msg" : "",
        FileNameWithoutExtension: InstanceName,
      });
    }
  }
  return uploadAttachmentRequestData;
};

const getFileNameWithoutExtension = (fileName) => {
  return fileName.split(".").slice(0, -1).join(".");
};

const removeInvalidChars = (data) => {
  return data.replace(/[<>:"\/\\|?*]/g, "");
};

const getAsFileAsyncPromise = () => {
  return new Promise((resolve) => {
    Office.context.mailbox.item.getAsFileAsync((asyncResult) => {
      if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
        resolve(asyncResult.value);
      } else {
        console.log("[getAsFileAsync] error", asyncResult);
        resolve("");
      }
    });
  });
};

const getAttachmentContentAsyncPromise = (attachmentId) => {
  return new Promise((resolve) => {
    Office.context.mailbox.item.getAttachmentContentAsync(attachmentId, (asyncResult) => {
      if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
        resolve(asyncResult.value);
      } else {
        console.log("[getAttachmentContentAsync] error", asyncResult);
        resolve("");
      }
    });
  });
};
